module.exports = __webpack_public_path__ + "img/Xc.30dad14d.png";